import { createAction, props } from '@ngrx/store';
import { ITask } from '@app/models/task.model';

enum ActionTypes {
    GetTasks = '[TASKS] Get Tasks',
    TasksLoaded = '[TASKS] Load success',
    ErrorTasks = '[TASKS] Error',
    BeginCreateTask = '[TASKS] Begin create task',
    SuccessCreateTask = '[TASKS] Success create task',
    BeginUpdateTask = '[TASKS] Begin update task',
    SuccessUpdateTask = '[TASKS] Success update task',
    SelectTask = '[TASKS] Select task'
}

export const GetTasksAction = createAction(
    ActionTypes.GetTasks
);

export const TasksLoadedAction = createAction(
    ActionTypes.TasksLoaded,
    props<{ payload }>()
);

export const ErrorTasksAction = createAction(
    ActionTypes.ErrorTasks, props<Error>()
);

export const BeginCreateTaskAction = createAction(
    ActionTypes.BeginCreateTask,
    props<{ payload: ITask }>()
);

export const SuccessCreateTaskAction = createAction(
    ActionTypes.SuccessCreateTask,
    props<{ payload }>()
);

export const BeginUpdateTaskAction = createAction(
    ActionTypes.BeginUpdateTask,
    props<{ payload: ITask }>()
);

export const SuccessUpdateTaskAction = createAction(
    ActionTypes.SuccessUpdateTask,
    props<{ payload }>()
);

export const SelectTaskAction = createAction(
    ActionTypes.SelectTask,
    props<{ payload: ITask }>()
);
